var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.558 5.30129C16.9475 4.90972 17.5803 4.90831 17.9715 5.29814L20.7995 8.1162C21.1908 8.50604 21.1922 9.13949 20.8027 9.53107L12.3242 18.0552C12.189 18.1912 12.0176 18.2853 11.8304 18.3265L8.22796 19.1189C7.51744 19.2751 6.88345 18.6436 7.03617 17.9317L7.81074 14.3211C7.851 14.1335 7.94435 13.9614 8.07965 13.8253L16.558 5.30129Z",
    stroke: "#8E97A3",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0947 8.20264L18.3394 12.4324",
    stroke: "#8E97A3",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.abcf3bee28dc11b05b3ad97d05c1528b.svg";
export { ForwardRef as ReactComponent };